exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-workflow-diagram .workflow-container{height:100%}.fts-workflow-diagram .workflow-diagram{width:100%;height:100%}", ""]);

// exports
